import api from "./axiosInstance";

/**
 * Register new user (free trial or paid plan)
 */
export const register = async (userData) => {
  const response = await api.post("/auth/register-company", userData);
  return response.data;
};

/**
 * Verify email with token
 */
export const verifyEmail = async (token) => {
  const response = await api.post("/auth/verify-email", { token });
  return response.data;
};

/**
 * Login user - uses legacy adapter for compatibility
 */
export const login = async (email, password) => {
  const response = await api.post("/auth/login-legacy", { email, password });
  const { access_token, token_type } = response.data;
  
  // Save tokens to localStorage
  localStorage.setItem("access_token", access_token);
  // For now, use access token as refresh token (legacy compatibility)
  localStorage.setItem("refresh_token", access_token);
  
  return response.data;
};

/**
 * Logout user
 */
export const logout = async () => {
  try {
    const refreshToken = localStorage.getItem("refresh_token");
    if (refreshToken) {
      await api.post("/auth/logout", { refresh_token: refreshToken });
    }
  } catch (error) {
    console.error("Logout error:", error);
  } finally {
    // Always clear local storage
    localStorage.clear();
  }
};

/**
 * Get current user info and status
 */
export const getMe = async () => {
  const response = await api.get("/me");
  return response.data;
};

/**
 * Resend verification email
 */
export const resendVerification = async (email) => {
  const response = await api.post("/auth/resend-verification", { email });
  return response.data;
};
